import { Banner } from 'components/Banner/Banner'
import { useMemo } from 'react'
import { TBusinessAccountDetails } from './types'
import { TYPOGRAPHY_WEIGHT, Typography } from 'components/Typography'
import {
  MOOV_SUPPORT_TEAM_EMAIL,
  RESOLUTION_LINK_ERROR_TEXT
} from './constants'
import { BUTTON_TYPES } from 'components/Button'
import { ReactComponent as Redirect } from 'assets/svg/RedirectWhite.svg'

export const DocumentFailerRiskWarningBanner = ({
  businessAccountDetails
}: {
  businessAccountDetails?: TBusinessAccountDetails
}) => {
  const showDocumentFailerRiskBanner = useMemo(() => {
    if (!businessAccountDetails) return false
    return businessAccountDetails.capabilities.some((capability) =>
      capability.requirements?.errors.some(
        (error) => error.error_code === 'document-failed-risk'
      )
    )
  }, [businessAccountDetails])

  if (!showDocumentFailerRiskBanner) return null
  return (
    <Banner.Warning
      text={''}
      className="document-failer-risk-warning-banner"
      button={[
        {
          buttonType: BUTTON_TYPES.PRIMARY,
          buttonIcon: <Redirect />,
          buttonText: 'Contact support team',
          onButtonClick: () => {
            window.open(`mailto:${MOOV_SUPPORT_TEAM_EMAIL}`, '_blank')
          }
        }
      ]}
      children={
        <div className="column gap-8 resolution-link-warning-block">
          <Typography.Body2 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
            Action required, issues detected with your submission.
          </Typography.Body2>
          <ul className="resolution-link-warning-block__errors">
            <li>{RESOLUTION_LINK_ERROR_TEXT['document-failed-risk']}</li>
          </ul>
          <Typography.Body2>
            To resolve these issues, please contact{' '}
            <span className="semibold">the support team.</span>
          </Typography.Body2>
        </div>
      }
    />
  )
}
